var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPeopleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 8.5C8.73896 8.5 10.25 6.98896 10.25 5.125C10.25 3.26104 8.73896 1.75 6.875 1.75C5.01104 1.75 3.5 3.26104 3.5 5.125C3.5 6.98896 5.01104 8.5 6.875 8.5Z",
    fill: "#C2F764"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 10.75C4.75203 10.75 2.86515 11.9084 1.66942 13.7038C1.40747 14.0971 1.2765 14.2937 1.29157 14.5449C1.30332 14.7405 1.43154 14.98 1.58783 15.0982C1.78856 15.25 2.06463 15.25 2.61677 15.25H11.1332C11.6854 15.25 11.9614 15.25 12.1622 15.0982C12.3185 14.98 12.4467 14.7405 12.4584 14.5449C12.4735 14.2937 12.3425 14.0971 12.0806 13.7038C10.8848 11.9084 8.99797 10.75 6.875 10.75Z",
    fill: "#C2F764"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.25 11.3777C14.3419 11.9262 15.2781 12.8065 15.9614 13.9072C16.0967 14.1252 16.1644 14.2342 16.1878 14.3851C16.2353 14.6918 16.0256 15.0689 15.74 15.1903C15.5994 15.25 15.4413 15.25 15.125 15.25M11.75 8.14918C12.8613 7.59692 13.625 6.45015 13.625 5.125C13.625 3.79985 12.8613 2.65308 11.75 2.10082M10.25 5.125C10.25 6.98896 8.73896 8.5 6.875 8.5C5.01104 8.5 3.5 6.98896 3.5 5.125C3.5 3.26104 5.01104 1.75 6.875 1.75C8.73896 1.75 10.25 3.26104 10.25 5.125ZM1.66942 13.7038C2.86515 11.9084 4.75203 10.75 6.875 10.75C8.99797 10.75 10.8848 11.9084 12.0806 13.7038C12.3425 14.0971 12.4735 14.2937 12.4584 14.5449C12.4467 14.7405 12.3185 14.98 12.1622 15.0982C11.9614 15.25 11.6854 15.25 11.1332 15.25H2.61677C2.06463 15.25 1.78856 15.25 1.58783 15.0982C1.43154 14.98 1.30332 14.7405 1.29157 14.5449C1.2765 14.2937 1.40747 14.0971 1.66942 13.7038Z",
    stroke: "#24352F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/people-icon.10835961.svg";
export { ForwardRef as ReactComponent };